import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const addLeaveType = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Leave Type',
    body
  );
  return data;
});
export const updateLeaveType = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Leave Type/${id}`,
    body
  );
  return data;
});

export const getLeaveType = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Leave Type?fields=["leave_type_name","name","max_leaves_allowed","include_holiday","is_earned_leave","earned_leave_frequency"]&order_by=name desc'
  );
  return data;
});
export const deleteLeaveType = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Leave Type/${record}`
  );
  return data;
});
export const getLeaveTypeDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Leave Type/${id}`
  );
  return data;
});
